import React, { useEffect, useRef } from "react";
import { Button } from "@progress/kendo-react-buttons";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormTextField from "../../components/formFields/FormTextField";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";
import { clearLeaveDetails } from "./leaveSlice";
import {
  createLeave,
  getAllActiveLeaves,
  getAllLeaves,
  getLeaveByID,
  updateLeave,
} from "./services/leave.services";
import { closed } from "../../components/muidrawer/muiDrawerSlice";
import { Typography } from "@progress/kendo-react-common";
import { RxCross1 } from "react-icons/rx";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { STATUSARRAY } from "../../_contstants/common";
// import { closed } from "../../components/drawer/drawerSlice";

const CreateLeave: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);

  const LeaveDetail = useAppSelector((state) => state.leave.LeaveDetail);
  const leave_guid = useAppSelector((state) => state.muidrawer.data);
  const formLoading = useAppSelector((state) => state.leave.formLoading);
  const isIndirect = useAppSelector((state) => state.muidrawer.isIndirect);

  useEffect(() => {
    return () => {
      dispatch(clearLeaveDetails());
      dispatch(closed());
    };
  }, []);

  useEffect(() => {
    if (leave_guid) {
      dispatch(getLeaveByID(leave_guid));
    }
  }, [leave_guid]);

  const handleSubmit = async (values: any) => {
    try {
      if (!leave_guid) {
        const insertPayload = {
          leave_type: values?.leave_type,
          leave_count: +values?.leave_count,
          isactive: values.isactive === 1,
        };
        const response = await dispatch(createLeave(insertPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearLeaveDetails());
          isIndirect
            ? dispatch(getAllActiveLeaves())
            : dispatch(getAllLeaves());
        }
      } else {
        const editPayload = {
          id: values?.id,
          leave_guid: leave_guid,
          leave_type: values?.leave_type,
          leave_count: +values?.leave_count,
          isactive: values.isactive === 1,
        };
        const response = await dispatch(updateLeave(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearLeaveDetails());
          isIndirect
            ? dispatch(getAllActiveLeaves())
            : dispatch(getAllLeaves());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const handleFormClose = () => {
    dispatch(closed());
  };

  if (formLoading) return <LoadingPanel gridRef={gridRef} />;

  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={LeaveDetail}
      render={(formRenderProps: FormRenderProps) => (
        <FormElement style={{ width: "100%" }}>
          <GridLayout
            style={{
              display: "flex",
              flexWrap: "wrap",
            }}
            gap={{ rows: 10 }}
            cols={[{ width: "100%" }]}
          >
            <GridLayoutItem
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                margin: "17px 0 8px",
              }}
            >
              <Typography.h4 className="m-0">
                {leave_guid ? "Update Leave" : "Add Leave"}
              </Typography.h4>
              <Button
                type="button"
                fillMode={"flat"}
                themeColor={"dark"}
                style={{ marginRight: 4 }}
                onClick={() => dispatch(closed())}
              >
                <RxCross1 />
              </Button>
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="leave_type"
                label="Leave Type"
                placeholder="Leave Type"
                component={FormTextField}
                validator={requiredValidator} astrike={true}
              />
            </GridLayoutItem>

            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="leave_count"
                label="Leave Count"
                placeholder="Leave Count"
                type="number"
                component={FormTextField}
                validator={requiredValidator} astrike={true}
              />
            </GridLayoutItem>

            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                id={"isactive"}
                name={"isactive"}
                label={"Status"}
                component={FormSelectionField}
                validator={requiredValidator} astrike={true}
                options={STATUSARRAY?.map((status: any) => {
                  return {
                    value: status.value,
                    label: status.label,
                  };
                })}
              />
            </GridLayoutItem>
            <GridLayoutItem
              colSpan={3}
              style={{
                textAlign: "start",
                marginTop: "20px",
                width: "100%",
              }}
            >
              <ButtonWithLoading
                label={leave_guid ? "Update" : "Save"}
                type="submit"
                disabled={!formRenderProps.allowSubmit || formLoading}
                loading={formLoading}
              />
              <Button
                type="button"
                fillMode={"outline"}
                themeColor={"primary"}
                style={{ marginLeft: 4 }}
                onClick={handleFormClose}
              >
                Cancel
              </Button>
            </GridLayoutItem>
          </GridLayout>
        </FormElement>
      )}
    />
  );
};

export default CreateLeave;
